if (!window.customElements.get('bundle-categories')) {
  window.customElements.define('bundle-categories', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      if (!this.tabs.length) return;

      this.addEventListener('click', this._onClick.bind(this));
      this.addEventListener('keydown', this._onKeydown.bind(this));
      /* Theme editor: selecting a category block reveals its panel. */
      this.addEventListener('shopify:block:select', function(event) {
        var tab = event.target.closest('[role="tab"]') ||
          this.tabs.find(function(t) { return event.target.id === t.getAttribute('aria-controls'); });
        if (tab) this.select(tab, false);
      }.bind(this));

      this._selectFromLocation();
    }

    get param() {
      return this.getAttribute('data-query-param') || 'category';
    }

    /* Deep links: ?category=<slug> or #<slug>, so a tab can be linked to
       from navigation or the quiz result. */
    _selectFromLocation() {
      var params = new URLSearchParams(window.location.search);
      var slug = params.get(this.param) || window.location.hash.replace('#', '');
      if (!slug) return;
      var tab = this.tabs.find(function(t) { return t.getAttribute('data-category') === slug; });
      if (tab) this.select(tab, false);
    }

    _onClick(event) {
      var tab = event.target.closest('[role="tab"]');
      if (tab) return this.select(tab);

      var quickBuy = event.target.closest('[data-quick-buy]');
      if (quickBuy) this._openQuickView(quickBuy.getAttribute('data-quick-buy'));
    }

    /* Bundles have a flavour option per component, so "Add to cart" opens
       the theme's quick view to collect them. */
    _openQuickView(productUrl) {
      var isPhone = window.matchMedia('(max-width: 740px)').matches;
      var element = this.querySelector(isPhone ? '[data-quick-buy-popover]' : '[data-quick-buy-drawer]');
      if (!element) return;
      var view = isPhone ? 'quick-buy-popover' : 'quick-buy-drawer';
      var target = productUrl + (productUrl.indexOf('?') >= 0 ? '&' : '?') + 'view=' + view;
      if (element.getAttribute('data-loaded-url') !== target) {
        element.innerHTML = '';
        element.setAttribute('href', target);
        element.setAttribute('data-loaded-url', target);
      }
      element.open = true;
    }

    _onKeydown(event) {
      var tab = event.target.closest('[role="tab"]');
      if (!tab) return;
      var offset = { ArrowLeft: -1, ArrowRight: 1, Home: -Infinity, End: Infinity }[event.key];
      if (offset === undefined) return;
      event.preventDefault();
      var index = this.tabs.indexOf(tab) + offset;
      var next = this.tabs[Math.min(Math.max(index, 0), this.tabs.length - 1)];
      this.select(next);
      next.focus();
    }

    /* Swaps a deferred panel's <template> for the real grid, once. */
    _hydrate(panel) {
      var template = panel.querySelector('template[data-bundle-grid]');
      if (template) template.replaceWith(template.content);
    }

    select(tab, updateUrl) {
      if (!this.tabs.includes(tab)) return;
      this.tabs.forEach(function(item) {
        var selected = item === tab;
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.tabIndex = selected ? 0 : -1;
        var panel = document.getElementById(item.getAttribute('aria-controls'));
        if (!panel) return;
        if (selected) this._hydrate(panel);
        panel.hidden = !selected;
      }, this);

      if (updateUrl === false) return;
      var url = new URL(window.location.href);
      url.searchParams.set(this.param, tab.getAttribute('data-category'));
      window.history.replaceState({}, '', url);
    }
  });
}
